let analytics = require('../../../actions/analytics');
let error = require('../../../actions/error');

exports.notFound = [
    analytics.parseUtmFromQuery,
    analytics.pageview,
    error.notFound('default 404 page', true)
];



// WEBPACK FOOTER //
// ./signals/pages/errors/index.js